import { CheckCircle2, XCircle, HelpCircle } from "lucide-react";
import { AppColorVariant } from "../../theme/AppColorVariant";

export enum DependencyHealthStatus {
  Online = "online",
  Offline = "offline",
  Skipped = "skipped",
}

export const DependencyHealthStatusLabels: Record<DependencyHealthStatus, string> = {
  [DependencyHealthStatus.Online]: "Online",
  [DependencyHealthStatus.Offline]: "Offline",
  [DependencyHealthStatus.Skipped]: "Skipped",
};

export const DependencyHealthStatusColors: Record<DependencyHealthStatus, AppColorVariant> = {
  [DependencyHealthStatus.Online]: "success",
  [DependencyHealthStatus.Offline]: "danger",
  [DependencyHealthStatus.Skipped]: "neutral",
};

export const DependencyHealthStatusIcons: Record<DependencyHealthStatus, React.ElementType> = {
  [DependencyHealthStatus.Online]: CheckCircle2,
  [DependencyHealthStatus.Offline]: XCircle,
  [DependencyHealthStatus.Skipped]: HelpCircle,
};
